import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '@env/environment';
@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private authService: AuthService, private http: HttpClient) {}
  private autoLogOutInstance: any;
  private heartBeatInstance: any;
  // private readonly api = `http://creditlimit.stg103.netsmartz.us/api/`;
  private api = environment.StagingUrl;

  startHeartBeat() {
    setTimeout(() => {
      try {

        const tokenno = this.authService.userToken;

        this.http
          .post(`${this.api}account/heartbeat`, { tokenNo: tokenno })
          .subscribe({
            next: (data) => {},
            error: (e) => {
            },
          });
      } catch (e) {
        console.log(e);
      }
    }, 5000);

    clearInterval(this.heartBeatInstance);

    this.heartBeatInstance = setInterval(() => {
      try {

        const tokenno = this.authService.userToken;

        this.http
          .post(`${this.api}account/heartbeat`, { tokenNo: tokenno })
          .subscribe({
            next: (data) => {},

            error: (e) => {
            },
          });
      } catch (e) {
        console.log(e);
      }
    }, 50000);
  }

  stopHeartBeat() {
    clearInterval(this.heartBeatInstance);
  }

  // autoLogOut(time: number) {
  //   clearTimeout(this.autoLogOutInstance);
  //   this.autoLogOutInstance = setTimeout(() => {
  //     this.authService.logOut();
  //   }, time);
  // }
}
